import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isUserPhysician() || AuthService.isMasterUser()) {
                return next()
            }
            return next({ name: 'index' })
        })
    },
}
